// extracted by mini-css-extract-plugin
export default {"group-mapping":"map-channel-messages_group-mapping__ULn6d","loading-value":"map-channel-messages_loading-value__gx17n"};